import {Space, Tag} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringAnswerType} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {AnswerMentionBadge} from './answer-mention-badge';
import {AnswerPositionTag} from './answer-position-tag';
import {AnswerSentimentTag} from './answer-sentiment-tag';
import {EXCLUDED_ANSWER_MODEL_STATUSES} from './answers-feed-const';

type PropsType = {
    answer: AiMonitoringAnswerType;
};

// Primary verdict: mentioned or not, and (only when mentioned) position + sentiment.
export function AnswerVerdict(props: PropsType): JSX.Element {
    const {answer} = props;
    const isExcluded = EXCLUDED_ANSWER_MODEL_STATUSES.has(answer.modelStatus);

    return (
        <Space align="center" size={[12, 8]} wrap>
            <AnswerMentionBadge brandMentioned={answer.brandMentioned} />
            {answer.brandMentioned && answer.position !== null ? (
                <AnswerPositionTag position={answer.position} />
            ) : null}
            {answer.brandMentioned && answer.sentiment ? <AnswerSentimentTag sentiment={answer.sentiment} /> : null}
            {isExcluded ? (
                <Tag color="error">
                    <Locale stringKey="AI_BRAND_MONITORING__ANSWERS__EXCLUDED" />
                </Tag>
            ) : null}
        </Space>
    );
}
